import { Expose } from 'class-transformer';

export class ReviewResponse {
  id!: string;
  comment!: string;
  rating!: number;
  medium!: number;

  @Expose({ name: 'gmb_address' })
  gmbAddress!: number;

  @Expose({ name: 'google_maps_clicked' })
  googleMapsClicked!: boolean;
}
